export default __webpack_public_path__ + "static/media/09_panna_mloda.4e9bb671.png";